'use client';
import React, { useState, useRef } from 'react';
// import { useRouter } from 'next/navigation';
import supabase from '@/lib/supabase';
import SignupModal from './SignupModal/SignupModal';
import LoginModal from './LoginModal/LoginModal';

export default function AuthModals({ isOpen = false, onClose }) {
  // const router = useRouter();
  const [showSignup, setShowSignup] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  // Signup state
  const [signUpData, setSignUpData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: ''
  });

  // Login state
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });

  // Signup CAPTCHA state
  const [signupCaptchaToken, setSignupCaptchaToken] = useState('');
  const [signupCaptchaLoading, setSignupCaptchaLoading] = useState(true);
  const [signupCaptchaError, setSignupCaptchaError] = useState('');
  const signupTurnstileRef = useRef(null);

  // Login CAPTCHA state
  const [loginCaptchaToken, setLoginCaptchaToken] = useState('');
  const [loginCaptchaLoading, setLoginCaptchaLoading] = useState(true);
  const [loginCaptchaError, setLoginCaptchaError] = useState('');
  const loginTurnstileRef = useRef(null);

  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data, error } = await supabase.auth.signUp({
        email: signUpData.email,
        password: signUpData.password,
        options: { captchaToken: signupCaptchaToken }
      });
      if (error) throw error;

      const res = await fetch('/api/create-user', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: data.user.id,
          email: signUpData.email,
          firstName: signUpData.firstName,
          lastName: signUpData.lastName,
        }),
      });
      if (!res.ok) throw new Error('Database creation failed');

      await supabase.auth.signOut();
      alert('Registration successful. Please check your email to confirm your signup.');
      setShowSignup(false);
      setShowLogin(true);
    } catch (err) {
      alert('Registration failed: ' + err.message);
      // Reset CAPTCHA after failed attempt
      if (signupTurnstileRef.current) {
        signupTurnstileRef.current.reset();
      }
      setSignupCaptchaToken('');
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: loginData.email,
        password: loginData.password,
        options: { captchaToken: loginCaptchaToken }
      });
      if (error) throw error;
      window.location.reload();
    } catch (err) {
      alert('Login failed: ' + err.message);
      // Reset CAPTCHA after failed attempt
      if (loginTurnstileRef.current) {
        loginTurnstileRef.current.reset();
      }
      setLoginCaptchaToken('');
    }
  };


  const handleGoogleSignIn = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
          scopes: 'email profile',
          queryParams: {
            access_type: 'offline',
            prompt: 'consent'
          }
        }
      });

      if (error) {
        console.error('OAuth error:', error);
        alert('Failed to sign in with Google. Please try again.');
      }
      // If successful, browser will redirect - no need to handle success
    } catch (err) {
      console.error('OAuth exception:', err);
      alert('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <>
      <SignupModal
        isOpen={isOpen && showSignup}
        onClose={onClose}
        onSwitchToLogin={() => { setShowSignup(false); setShowLogin(true); }}
        onSubmit={handleSignupSubmit}
        onGoogleSignIn={handleGoogleSignIn}
        {...signUpData}
        setFirstName={(v) => setSignUpData(prev => ({ ...prev, firstName: v }))}
        setLastName={(v) => setSignUpData(prev => ({ ...prev, lastName: v }))}
        setEmail={(v) => setSignUpData(prev => ({ ...prev, email: v }))}
        setPassword={(v) => setSignUpData(prev => ({ ...prev, password: v }))}
        captchaToken={signupCaptchaToken}
        setCaptchaToken={setSignupCaptchaToken}
        captchaLoading={signupCaptchaLoading}
        setCaptchaLoading={setSignupCaptchaLoading}
        captchaError={signupCaptchaError}
        setCaptchaError={setSignupCaptchaError}
        turnstileRef={signupTurnstileRef}
      />

      <LoginModal
        isOpen={isOpen && showLogin}
        onClose={onClose}
        onSwitchToSignup={() => { setShowLogin(false); setShowSignup(true); }}
        onSubmit={handleLoginSubmit}
        onGoogleSignIn={handleGoogleSignIn}
        {...loginData}
        setEmail={(v) => setLoginData(prev => ({ ...prev, email: v }))}
        setPassword={(v) => setLoginData(prev => ({ ...prev, password: v }))}
        captchaToken={loginCaptchaToken}
        setCaptchaToken={setLoginCaptchaToken}
        captchaLoading={loginCaptchaLoading}
        setCaptchaLoading={setLoginCaptchaLoading}
        captchaError={loginCaptchaError}
        setCaptchaError={setLoginCaptchaError}
        turnstileRef={loginTurnstileRef}
      />
    </>
  );
}